import { useState } from "react";
import AdminAPI from 'api/adminapi';
import * as yup from "yup";
import {useFormik} from "formik";
import {Messages} from "app_constants";
import {useSelector} from "react-redux";
import { RootState } from '@custom-types/RootState';
import {Modal, Container, Row, Col, Form, Button} from "react-bootstrap";
import Loading from "components/Loading";
import ReqState from "lib/reqstate";


export default function AuthDialog({
  show, onClose
}: {
  show: boolean,
  onClose: () => void,
}) {
  const isLogin = useSelector((state: RootState) => state.appState.isLogin);
  const [sendingState, setSendingState] = useState(ReqState.INIT);

  const f = useFormik({
    initialValues: {
      idkind: "U",
      siteName: "",
      loginid: "",
      password: "",
    },
    validationSchema: yup.object().shape({
      loginid: yup.string().required(Messages.RequireError),
      password: yup.string().required(Messages.RequireError),
    }),
    onSubmit: async (values) => {
      try {
        setSendingState(ReqState.DOING);
        await AdminAPI.login(values);
        setSendingState(ReqState.DONE);
        onClose();
      }
      catch(e: unknown) {
        setSendingState(ReqState.ERROR);
      }
    }
  });

  function handleLogout() {
    AdminAPI.logout(false);
  }


  return (
    <Modal
      show={show}
      animation={false}
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title>
          ログイン
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Loading
          isSendError={sendingState == ReqState.ERROR}
          errorMsg={Messages.ServerError}
        />
        <Container>
          <Row className="mb-2 d-flex align-items-center">
            <Col>
              <Form.Label htmlFor="siteName">サイト名</Form.Label>
            </Col>
            <Col>
              <Form.Control disabled={isLogin} id="siteName" type="text" name="siteName" value={f.values.siteName} onChange={f.handleChange} />
            </Col>
          </Row>
          <Row className="mb-2 d-flex align-items-center">
            <Col>
              <Form.Label htmlFor="loginid">ID</Form.Label>
            </Col>
            <Col>
              <Form.Control disabled={isLogin} id="loginid" type="text" name="loginid" value={f.values.loginid} onChange={f.handleChange} />
            </Col>
          </Row>
          <Row className="mb-2 d-flex align-items-center">
            <Col>
              <Form.Label htmlFor="password">パスワード</Form.Label>
            </Col>
            <Col>
              <Form.Control disabled={isLogin} id="password" type="password" name="password" value={f.values.password} onChange={f.handleChange} />
            </Col>
          </Row>
          <Row>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Loading
          isLoading={sendingState == ReqState.DOING}
        >
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          {!isLogin ? 
              <Button onClick={() => f.handleSubmit()}>ログイン</Button>
            :
              <Button onClick={() => handleLogout()}>ログアウト</Button>
          }
        </Loading>
      </Modal.Footer>
    </Modal>
  )
}
